export enum ViewTypes {
	normal = 0,
	edit = 1,
	preview = 2,
	none = -1,
}
